import React from 'react';
import propTypes2 from 'prop-types';

import { arePathsEqual } from '../utils/arePathsEqual';
import { camelize } from '../utils/String';

const evtNames = ['click', 'mouseout', 'mouseover', 'dragend'];

const wrappedPromise = function () {
  var wrappedPromise = {},
    promise = new Promise(function (resolve, reject) {
      wrappedPromise.resolve = resolve;
      wrappedPromise.reject = reject;
    });
  wrappedPromise.then = promise.then.bind(promise);
  wrappedPromise.catch = promise.catch.bind(promise);
  wrappedPromise.promise = promise;

  return wrappedPromise;
};

export class Circle extends React.Component {
  componentDidMount() {
    this.circlePromise = wrappedPromise();
    this.renderCircle();
  }

  componentDidUpdate(prevProps) {
    const { path, map } = this.props;

    if (this.propsChanged(prevProps) || map !== prevProps.map || !arePathsEqual(path, prevProps.path)) {
      this.destroyCircle();
      this.renderCircle();
    }
  }

  centerChanged = (newCenter) => {
    const { lat, lng } = this.props.center;
    return lat !== newCenter.lat || lng !== newCenter.lng;
  };

  propsChanged = (newProps) => {
    if (this.centerChanged(newProps.center)) return true;

    return Object.keys(Circle.propTypes2).some((key) => this.props[key] !== newProps[key]);
  };

  componentWillUnmount() {
    this.destroyCircle();
  }

  destroyCircle = () => {
    if (this.circle) {
      this.circle.setMap(null);
    }
  };

  renderCircle() {
    const {
      map,
      google,
      center,
      radius,
      strokeColor,
      strokeOpacity,
      strokeWeight,
      fillColor,
      fillOpacity,
      draggable,
      visible,
      setCircle,
      ...props
    } = this.props;

    if (!google) {
      return null;
    }

    const params = {
      ...props,
      map,
      center,
      radius,
      draggable,
      visible,
      options: {
        strokeColor,
        strokeOpacity,
        strokeWeight,
        fillColor,
        fillOpacity,
      },
    };

    this.circle = new google.maps.Circle(params);

    evtNames.forEach((e) => this.circle.addListener(e, this.handleEvent(e)));

    this.circle.addListener('radius_changed', this.props.onRadiusChanged);
    this.circlePromise.resolve(this.circle);
    setCircle(this.circle);
  }

  getCircle() {
    return this.circlePromise;
  }

  handleEvent(evt) {
    return (e) => {
      const evtName = `on${camelize(evt)}`;
      if (this.props[evtName]) {
        this.props[evtName](this.props, this.circle, e);
      }
    };
  }

  render() {
    return null;
  }
}

Circle.propTypes2 = {
  center: propTypes2.object,
  radius: propTypes2.number,
  strokeColor: propTypes2.string,
  strokeOpacity: propTypes2.number,
  strokeWeight: propTypes2.number,
  fillColor: propTypes2.string,
  fillOpacity: propTypes2.number,
  draggable: propTypes2.bool,
  visible: propTypes2.bool,
};

// evtNames.forEach(e => Circle.propTypes2[e] = propTypes2.func)

Circle.defaultProps = {
  name: 'Circle',
};
